import { Form as AntForm } from 'antd'
import type { ComponentProps } from 'react'

type AntFormProps = ComponentProps<typeof AntForm>

export interface AppFormProps extends AntFormProps {}

export const AppForm = ({ ...rest }: AppFormProps) => <AntForm {...rest} />

export const AppFormItem = AntForm.Item

export const AppFormList = AntForm.List

export const AppFormItemProvider = AntForm.Provider

export const useAppForm = AntForm.useForm

export const useAppWatch = AntForm.useWatch
